<template>
  <BFormGroup
    :state="state"
    :invalid-feedback="errorMessage"
    class="mb-3"
  >
    <BFormLabel :required="required" :forId="inputId" :id="labelId" :class="{'fw-bold': required}">
      {{ inputLabel }}
    </BFormLabel>
    <BFormInput
      v-model="inputValue"
      :state="state"
      :id="inputId"
      :name="inputName"
      maxlength="255"
      size="255"
      :type="type"
      :class="{ 'fw-bold': required, 'mb-3': true }"
      :autocomplete="autocompleteAttr"
      :disabled="disabled"
      :aria-required="required ? 'true' : undefined"
      :aria-invalid="invalid ? 'true' : undefined"
      :aria-labelledby="labelId"
    >
    </BFormInput>
    <small v-if="hint" class="form-text text-muted d-block">
      {{ hint }}
    </small>
  </BFormGroup>
</template>

<script>
import BFormLabel from './BFormLabel.vue'
import { BFormGroup, BFormInput } from 'bootstrap-vue-next'

export default {
  data() {
    return {
      identifierValue: this.value,
      errorMessages: this.errors,
      stateCd: this.state_cd,
    }
  },
  components: {
    BFormGroup, BFormLabel, BFormInput
  },
  computed: {
    autocompleteAttr() {
      return this.autocomplete ? "on" : "off";
    },
    state() {
      return this.invalid ? false : null
    },
    invalid() {
      return !!this.errorMessages.length;
    },
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    inputName() {
      return `${this.modelName}[${this.attrName}]`;
    },
    inputId() {
      return `${this.modelName}_${this.attrName}`;
    },
    labelId() {
      return `${this.inputId}_label`;
    },
    buttonId() {
      return `search_${this.inputId}`;
    },
    errorMessage() {
      return this.errorMessages.join(' and ');
    },
    lookupPath() {
      return `/api/v1/identifiers/${this.identifierValue}`
    },
    inputLabel() {
      return this.label || `${this.qualifier} Number`
    }
  },
  props: {
    qualifier: {
      type: String,
      default: null
    },
    value: {
      type: String,
      required: false
    },
    state_cd: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: true
    },
    modelName: {
      type: String,
      required: true
    },
    attrName: {
      type: String,
      required: true
    },
    errors: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      required: false
    },
    type: {
      type: String,
      default: "text"
    },
    autocomplete: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    notFoundError: {
      type: String,
      default: "We could not find a matching record."
    },
    noQualifierProvidedError: {
      type: String,
      required: false
    },
  },
  methods: {
    makeRequest() {
      let vm = this;

      axios.get(vm.lookupPath, {
        params: {
          qualifier: this.qualifier,
          state_cd: this.stateCd
        }
      }).then(function (response) {
        vm.$emit('found', vm.qualifier, response.data);
        vm.errorMessages = [];
      })
          .catch(function (error) {
            vm.errorMessages = [vm.notFoundError];
          });
    },
    search() {
      if (this.qualifier) {
        this.makeRequest();
      } else if (this.noQualifierProvidedError) {
        this.errorMessages = [this.noQualifierProvidedError];
      }
    }
  }
}
</script>
